// import React from 'react';
// import clsx from 'clsx';
// import PropTypes from 'prop-types';
// import { makeStyles } from '@material-ui/styles';
// import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
// import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
// import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';


// const useStyles = makeStyles(theme => ({
//   root: {
//     height: '100%'
//   },
//   content: {
//     alignItems: 'center',
//     display: 'flex'
//   },
//   title: {
//     fontWeight: 700
//   },
//   avatar: {
//     backgroundColor:props=>props.backColorIcon,
//     height: 56,
//     borderRadius:10,
//     width: 56
//   },
//   icon: {
//     height: 32,
//     width: 32
//   },
//   difference: {
//     marginTop: theme.spacing(2),
//     display: 'flex',
//     alignItems: 'center'
//   },
//   differenceIcon: {
//     color: props=> props.percent > 0 ?theme.palette.success.dark:theme.palette.error.dark
//   },
//   differenceValue: {
//     color:props=> props.percent > 0 ?theme.palette.success.dark:theme.palette.error.dark,
//     marginRight: theme.spacing(.01),
//   },
//   differenceCaption:{
//     marginRight: theme.spacing(.3)
//   }

// }));




// const ReportBox = props => {
//   const { className, ...rest } = props;

//   const classes = useStyles(props);
//   let captionIcon=null;
//       if(props.percent > 0 ) {
//        captionIcon= (<ArrowUpwardIcon className={classes.differenceIcon}/>);
//       }else
//         captionIcon=( <ArrowDownwardIcon className={classes.differenceIcon} />);
//   return (
//     <Card
//       {...rest}
//       className={clsx(classes.root, className)}
//     >
//       <CardContent>
//         <Grid
//           container
//           justify="space-between"
//         >
//           <Grid item>
//             <Typography
//               className={classes.title}
//               color="textSecondary"
//               gutterBottom
//               variant="body2"
//             >
//               {props.title}
//             </Typography>
//             <Typography variant="h3">{props.value}</Typography>
//           </Grid>
//           <Grid item>
//             <Avatar className={classes.avatar}>
//               {props.icon}
//             </Avatar>
//           </Grid>
//         </Grid>
//         {props.percent && <div className={classes.difference}>
//          {captionIcon}
//           <Typography
//             className={classes.differenceValue}
//             variant="body2"
//           >
//             ٪{props.percent}
//           </Typography>
//           <Typography
//             className={clsx(classes.caption,classes.differenceCaption)}
//             variant="caption"
//           >
//            نسبت به ماه قبل
//           </Typography>
//         </div>}
//       </CardContent>
//     </Card>
//   );
// };

// ReportBox.propTypes = {
//   className: PropTypes.string
// };

// export default ReportBox;
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';


const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor:props=>props.backColorIcon,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  GridBackground:{
    backgroundColor:props=>props.backColorIcon,
    padding:5,borderRadius:5,position:'absolute',left:10,top:-10
  },
  differenceIcon: {
    color: props=> props.percent > 0 ?theme.palette.success.dark:theme.palette.error.dark
  },
  differenceValue: {
    color:props=> props.percent > 0 ?theme.palette.success.dark:theme.palette.error.dark,
    marginRight: theme.spacing(.01),
  },
  differenceCaption:{
    marginRight: theme.spacing(.3)
  }

}));




const ReportBox = props => {
  const { className, ...rest } = props;

  const classes = useStyles(props);
  let captionIcon=null;
      if(props.percent > 0 ) {
       captionIcon= (<ArrowUpwardIcon className={classes.differenceIcon}/>);
      }else
        captionIcon=( <ArrowDownwardIcon className={classes.differenceIcon} />);
  return (
    <Card
    style={{position:'relative',overflow:'unset'}}

      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent           >
        <Grid
        >
          <Grid item > 
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="caption"
            >
              {props.title}
            </Typography>
            <Typography variant="h3">{props.value}</Typography>
          </Grid>
          <Grid item className={classes.GridBackground}>
            <Avatar className={classes.avatar}>
              {props.icon}
            </Avatar>
          </Grid>
        </Grid>
        {props.percent && <div className={classes.difference}>
         {captionIcon}
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            ٪{props.percent}
          </Typography>
          <Typography
            className={clsx(classes.caption,classes.differenceCaption)}
            variant="caption"
          >
           نسبت به ماه قبل
          </Typography>
        </div>}
      </CardContent>
    </Card>
  );
};

ReportBox.propTypes = {
  className: PropTypes.string
};

export default ReportBox;

